
import type {AbnormalHospital, AbnormalSummary} from "@/types";
import {fetchAbnormalSummary} from "@/services/api";
import {normalizeProvinceKey, toProvinceDisplayName} from "@/utils/provinces.ts";
import {formatBatch, resolveLevel, levelTheme} from '@/utils/format.ts';
import {IconHome} from "@/assets/icons/IconHome.tsx";

export const HospitalItem = ({hospital, onClick}: { hospital: AbnormalHospital; onClick: () => void })=> {
    const displayLevel = resolveLevel(hospital.iraiLevel, hospital.iraiScore);
    const theme = levelTheme(displayLevel);
    const subtitle = [hospital.region, toProvinceDisplayName(hospital.province), hospital.segment].filter(Boolean).join(' / ');

    return (
        <div
            onClick={onClick}
            style={{
                display: 'flex', alignItems: 'flex-start', gap: 10, padding: '12px 0',
                borderBottom: '1px solid #f1f5f9', cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
                (e.currentTarget as HTMLDivElement).style.background = '#f8fafc';
            }}
            onMouseLeave={(e) => {
                (e.currentTarget as HTMLDivElement).style.background = 'transparent';
            }}
        >
            <IconHome size={24}/>
            <div style={{flex: 1, minWidth: 0}}>
                <div style={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: '#1e293b',
                    marginBottom: 2,
                    lineHeight: 1.4
                }}>{hospital.name}</div>
                <div style={{fontSize: 11, color: '#64748b'}}>{subtitle}</div>
            </div>
            <span style={{
                fontSize: 12, fontWeight: 700, padding: '3px 10px', borderRadius: 10, flexShrink: 0,
                background: theme.bg, color: theme.fg,
            }}>
                {displayLevel}
              </span>
        </div>
    );
}
